import type { AppDefinition } from '../types';

/** Saudi National Bank — direct payout rails. No connector yet. */
export const SNB_APP: AppDefinition = {
  id: 'snb',
  nameKey: 'apps.snb.name',
  descriptionKey: 'apps.snb.description',
  logo: '/images/apps/snb-logo.svg',
  categories: ['banks'],
  status: 'soon',
  label: 'soon',
};
